const ru = {
    title: "АГЕНТСТВО ПО ИНТЕЛЛЕКТУАЛЬНОЙ СОБСТВЕННОСТИ ПРИ МИНИСТЕРСТВЕ ЮСТИЦИИ РЕСПУБЛИКИ УЗБЕКИСТАН",
    headerLinks: {
        agency: "Агентство",
        activity: "Деятельность",
        news: 'НОВОСТИ',
        services: 'УСЛУГИ',
        regulations: 'нормативно-правовые акты',
        informationService: 'информационная служба',
        contact: 'контакты'
    },
    titles: {
        ads: 'Объявления',
        services: 'Услуги',
        state: 'Государственные',
        interactive: 'Интерактивные',
        news: 'Новости',
        pressRelease: 'Пресс-релиз',
        meets: 'Мероприятия',
        media: 'Медиатека',
        gallery: 'ФОТОГАЛЕРЕЯ',
        videoGallery: 'ВИДЕОГАЛЕРЕЯ',
        viewAll: 'Посмотреть все',
        area: 'Территории',
        useFullLinks: 'Полезные ссылки',
        onlineNow: 'Сейчас на сайте:',
        users: 'пользователей',
        subscribes: 'Подписывайтесь на наши новости',
        email: 'Введите свой E-mail',
        follow: 'Подписаться',
        acts: 'Н-правовые акты',
        infoService: 'Инфо-служба',
        social: 'Соцсети',
        contacts: 'Контакты'
    },
    links: {
        agency: {
            aboutAgency: 'Обо агенстве',
            structureAgency: 'Структура агенства',
            managent: 'Руководство',
            departments: 'Отделы агентсво',
            organization: 'Подведомственные организации',
            technicalCouncil: 'Научно-технический совет',
            boardAppeal: 'Апелляционный совет',
            publicCounsil: 'Общественный совет',
            patentFund: 'Государственный патентный фонд',
            awards: 'Награждение сотрудников',
            requisites: 'Реквизиты',
            vacancy: 'Вакансии',
            questions: 'Вопросы и ответы',
            contacts: 'Контакты',
            collegue: 'Коллегия'
        },
        activity: {
            intellectualProperty: 'Интеллектуальная собственность',
            verifiedPatents: 'Проверенные патенты',
            internationalCooperation: 'Международное сотрудничество',
            againstCorruption: 'Борьба с коррупцией',
            arbitrage: 'Судебная практика',
            statistics: 'Статистика',
            tenders: 'Объявление и тендеры',
            awards: 'Арбитражные решения',
            licence: 'Лицензирование',
            governMent: 'Электронное правительство',
            brotherHood: 'Oбращение граждан',
            openSourses: 'Открытые данные',
            univiersities: 'Политика интеллектуальной собственности в университетах'
        },
        services: {
            inventions: 'Изобретения',
            utility: 'Полезные модели',
            appelations: 'Наименования мест происхождения товаров',
            databases: 'Программа для ЭВМ и базы данных',
            industrial: 'Промышленные образцы',
            achievments: 'Селекционные достижения',
            serviceMarks: 'Товарные знаки, знаки обслуживания',
            topologies: 'Топологии интегральных микросхем',
            register: 'Регистрация патентных поверренных',
            attestetion: 'Проведение аттестации кандидата в патентные поверенные',
            carrying: 'Проведение аттестации патентных поверенных'
        },
        acts: {
            internationalActs: 'Международные нормативные акты',
            lawsUzb: 'Законы Республики Узбекистан',
            decrees: 'Указы и постановления Президента',
            ministres: 'Постановления кабинета Министров',
            industry: 'Отраслевые нормативно-правовые акты',
            docs: 'Документы утратившие силу',
            category: 'Тарифы и пошлины',
            projects: 'Проекты'
        },
        infoService: {
            performence: 'Выступление и протоколы руководство',
            media: 'Аккредитация представителей СМИ',
            giwe: 'Конкурсы',
            mediaPlan: 'Медиа план и пресс- релизы',
            mediatec: 'Медиатека',
            editions: 'Издания'
        },
        news: {
            news: 'Новости',
            pressRelease: 'Пресс-релиз',
            meets: 'Мероприятия',
            ads: 'Объявление'
        }
    }
}

export default ru